import { reports } from "./reports";

export const reserveV2 = {
	title: "Reservation settings",
	description:
		"Brief page description with up to 100 characters. Do not change this field size.",
	mainTabs: {
		management: "Management",
		reports: "Reports",
		configurations: "Settings",
		loading: "Loading...",
		disabledTooltip: "Configure reservation rules first",
	},
	sideMenu: {
		title: "Reservation settings",
		reserveRules: {
			title: "Reservation rules",
			description: "Configure interval window and tolerance",
		},
		roomsAndSchedule: {
			title: "Rooms & schedule grid",
			description: "Create and edit rooms, schedule grid and tables for reservations",
		},
		shifts: {
			title: "Shifts",
			description: "Configure shifts to facilitate reservation operation",
		},
		specialDates: {
			title: "Special dates",
			description: "Configure dates with different schedules",
			emptyState: {
				title: "There's nothing here yet.",
				description: "Configure dates when the schedule will differ from the standard.",
			},
			loading: "Loading special dates...",
			error: "Error loading special dates:",
			newDateButton: "New date",
			filters: {
				roomPlaceholder: "Filter by room",
				allRooms: "All rooms",
				periodPlaceholder: "Filter by period",
				today: "Today",
				thisWeek: "This week",
				thisMonth: "This month",
				thisQuarter: "This quarter",
			},
			table: {
				date: "Date",
				title: "Title",
				startTime: "Start time",
				endTime: "End time",
				room: "Room",
			},
			actions: {
				edit: "Edit",
				delete: "Delete",
			},
			notifications: {
				deleted: {
					title: "Special date deleted",
					message: "The special date was successfully removed.",
				},
				deleteError: {
					title: "Something went wrong",
					message: "Could not delete the special date. Please try again later.",
				},
			},
			drawer: {
				newTitle: "New special date",
				editTitle: "Edit special date",
				buttons: {
					close: "Close",
					create: "Create special date",
					update: "Update special date",
					creating: "Creating...",
					updating: "Updating...",
				},
			},
			form: {
				titleLabel: "Title",
				titlePlaceholder: "Ex: World Flavors Night",
				dateLabel: "Date",
				datePlaceholder: "Select date",
				allDaySwitch: "Mark as all day",
				startTimeLabel: "Start time",
				endTimeLabel: "End time",
				roomLabel: "Room",
				roomPlaceholder: "Select one or more rooms for this special date",
				validation: {
					titleRequired: "Please enter a title",
					dateRequired: "Please select a date",
					startTimeRequired: "Please enter the start time",
					endTimeRequired: "Please enter the end time",
					roomRequired: "Please select at least one room",
					invalidDate: "Invalid date",
					validationTitle: "Validation",
				},
			},
		},
		blockedDates: {
			title: "Blocked dates",
			description: "Configure dates when the place or room will be closed",
			emptyState: {
				title: "There's nothing here yet.",
				description: "Configure dates when the place or room will be closed.",
			},
			loading: "Loading blocked dates...",
			error: "Error loading blocked dates:",
			newDateButton: "New date",
			allDay: "All day",
			filters: {
				roomPlaceholder: "Filter by room",
				allRooms: "All rooms",
				periodPlaceholder: "Filter by period",
				today: "Today",
				thisWeek: "This week",
				thisMonth: "This month",
				thisQuarter: "This quarter",
			},
			table: {
				date: "Date",
				title: "Title",
				startTime: "Start time",
				endTime: "End time",
				room: "Room",
			},
			actions: {
				edit: "Edit",
				delete: "Delete",
			},
			notifications: {
				deleted: {
					title: "Blocked date deleted",
					message: "The blocked date was successfully removed.",
				},
				deleteError: {
					title: "Something went wrong",
					message: "Could not delete the blocked date. Please try again later.",
				},
			},
			drawer: {
				newTitle: "New blocked date",
				editTitle: "Edit blocked date",
				buttons: {
					close: "Close",
					create: "Create new block",
					update: "Update blocked date",
					creating: "Creating...",
					updating: "Updating...",
				},
			},
			form: {
				titleLabel: "Title",
				titlePlaceholder: "Ex: Scheduled maintenance",
				dateLabel: "Date",
				datePlaceholder: "Select date",
				allDaySwitch: "Mark as all day",
				startTimeLabel: "Start time",
				endTimeLabel: "End time",
				roomLabel: "Room",
				roomPlaceholder: "Select one or more rooms to block reservations on this date",
				validation: {
					titleRequired: "Please enter the title",
					dateRequired: "Please select a date",
					roomRequired: "Please select at least one room",
					invalidDate: "Invalid date",
					validationTitle: "Validation",
				},
			},
		},
		communication: {
			title: "Communication",
			description: "Enable or disable message sending",
			headerTitle: "Send SMS to customers",
			loading: "Loading...",
			alert: {
				costInfo: "Sent messages cost {{cost}}/message.",
			},
			fields: {
				reminder: "First contact",
				confirmation: "Reservation confirmation",
				dayOf: "On the day of reservation",
				late: "Late",
			},
			buttons: {
				discard: "Discard changes",
				save: "Save changes",
				saving: "Saving...",
			},
		},
	},
	roomsContent: {
		title: "Rooms",
		newRoomButton: "New room",
		roomName: "Room name",
		roomId: "Room ID",
	},
	shifts: {
		title: "Shifts",
		newShiftButton: "New shift",
		editShiftLabel: "Edit shift",
		deleteShiftLabel: "Delete shift",
		breakfast: "Breakfast",
		lunch: "Lunch",
		dinner: "Dinner",
		emptyState: {
			title: "There's nothing here yet.",
			description:
				"Create a new shift to facilitate reservation management in the operation.",
		},
	},
	newShiftDrawer: {
		title: "New shift",
		shiftNameLabel: "Shift name",
		shiftNamePlaceholder: "Enter shift name",
		startTimeLabel: "Start time",
		endTimeLabel: "End time",
		buttons: {
			close: "Close",
			create: "Create shift",
		},
		errors: {
			required: "This field is required",
		},
	},
	roomsAndSchedule: {
		title: "Rooms",
		newRoomButton: "New room",
		days: {
			sunday: "Sunday",
			monday: "Monday",
			tuesday: "Tuesday",
			wednesday: "Wednesday",
			thursday: "Thursday",
			friday: "Friday",
			saturday: "Saturday",
		},
		dayInitials: {
			sunday: "S",
			monday: "M",
			tuesday: "T",
			wednesday: "W",
			thursday: "T",
			friday: "F",
			saturday: "S",
		},
		timeFormat: "{{startTime}} to {{endTime}}",
		loading: "Loading rooms...",
		loadingSchedules: "Loading schedules...",
		error: "Error loading rooms:",
		menuItems: {
			showSchedule: "Show schedule grid",
			hideSchedule: "Hide schedule grid",
			editRoom: "Edit room",
			deleteRoom: "Delete room",
		},
		notifications: {
			roomDeleted: {
				title: "Room deleted successfully",
				message: "The room was removed successfully.",
			},
			roomDeleteError: {
				title: "Something went wrong",
				message: "Error deleting room.",
			},
			loadSchedulesError: {
				title: "Error loading",
				message: "Error loading room schedules.",
			},
			roomCreated: {
				title: "Room created successfully",
				message: "The room was created successfully.",
			},
			roomCreateError: {
				title: "Error creating",
				message: "Error creating room. Please try again.",
			},
			schedulesError: {
				title: "Something went wrong",
				message:
					"Room created, but there was an error creating the schedules. Please add them manually.",
			},
		},
		creatingRoom: "Creating room...",
		creatingSchedules: "Creating schedules...",
		emptyState: {
			title: "There's nothing here yet",
			description: "Create a new room to allow your customers to make reservations",
			noSettingsTitle: "Configure reservation rules first",
			noSettingsDescription:
				"You need to configure reservation rules before creating rooms and schedule grid",
			actionButton: "Configure reservation rules",
		},
	},
	newRoomDrawer: {
		title: "New room",
		editTitle: "Edit room",
		buttons: {
			close: "Close",
			createRoom: "Create room",
			saveChanges: "Save changes",
		},
		sideMenu: {
			configSection: "Room config",
			roomData: "Room data",
			schedulesByDay: "Schedules by day",
		},
		form: {
			roomDataTitle: "Room data",
			roomName: {
				label: "Room name",
				placeholder: "Enter room name",
			},
			roomCapacity: {
				label: "Room capacity per time slot",
				placeholder: "Enter room capacity",
			},
			activateRoom: "Activate room for reservations",
			importSchedule: "Import schedule from another day or room",
		},
		replicateScheduleLabel: "Replicate schedule grid to other days of the week",
		importScheduleLabel: "Import schedule grid from another day or room",
		days: {
			sunday: "Sunday",
			monday: "Monday",
			tuesday: "Tuesday",
			wednesday: "Wednesday",
			thursday: "Thursday",
			friday: "Friday",
			saturday: "Saturday",
		},
		notifications: {
			roomUpdated: {
				title: "Room updated successfully",
				message: "The room was updated successfully.",
			},
			roomUpdateError: {
				title: "Something went wrong",
				message: "We couldn't save the changes. Please try again later.",
			},
			scheduleError: {
				title: "Something went wrong",
				message: "Room updated, but there was an error saving some schedules.",
			},
		},
		dayScheduleView: {
			schedulesTitle: "{{day}} schedules",
			emptyState: "No schedules registered",
			newScheduleButton: "New schedule",
		},
		newScheduleModal: {
			title: "New schedule",
			editTitle: "Edit schedule",
			startTimeLabel: "Start time",
			endTimeLabel: "End time",
			scaleLabel: "Scale (minutes)",
			scalePlaceholder: "Select scale",
			scaleOptions: {
				minutes15: "15 minutes",
				minutes30: "30 minutes",
				minutes45: "45 minutes",
				minutes60: "60 minutes",
			},
			buttons: {
				cancel: "Cancel",
				save: "Save",
			},
			errors: {
				startTimeRequired: "Start time is required",
				endTimeRequired: "End time is required",
				endTimeAfterStart: "End time must be after start time",
				scaleRequired: "Scale is required",
				scaleInvalid: "Scale must be 15, 30, 45, or 60 minutes",
			},
		},
	},
	reserveRulesContent: {
		loading: "Loading settings...",
		errorLoading: "Error loading settings:",
		sections: {
			generalRules: "General rules",
			reservationParameters: "Reservation parameters",
			customerSite: "Customer site",
		},
		fields: {
			calendarWindow: {
				label: "Calendar interval window",
				placeholder: "Enter the interval in days",
				tooltip: "Number of days into the future that your reservations will be open.",
			},
			delayTolerance: {
				label: "Delay tolerance limit",
				placeholder: "Enter the tolerance limit...",
				tooltip:
					"Time in minutes after which reservations will be automatically cancelled.",
			},
			peopleLimit: {
				label: "People limit per reservation",
				placeholder: "Enter the maximum number...",
				tooltip: "Maximum number of people allowed per reservation",
			},
			rulesAndConditions: {
				label: "Reservation rules and conditions",
				placeholder:
					"Enter the reservation rules and conditions that will be shown to the customer at the time of booking",
			},
		},
		switches: {
			autoConfirm: {
				label: "Automatic reservation confirmation",
				description:
					"Your customers will have their reservation requests confirmed automatically.",
			},
			requireCPF: {
				label: "ID number required",
				description:
					"At the time of booking, the customer can only proceed if they provide a valid ID number",
			},
			requireBirthDate: {
				label: "Birth date required",
				description:
					"At the time of booking, the customer can only proceed if they enter their birth date",
			},
		},
		imageUpload: {
			label: "Site image",
			tooltip: "Upload the image that will be used on the site.",
			alt: "Site image",
			changeImage: "Change image",
			addImage: "Add image",
			hint: "File type .png, .jpg, and .jpeg up to 1MB",
		},
		siteUrl: {
			label: "Reservation site",
			placeholder: "restaurantname",
		},
		buttons: {
			discardChanges: "Discard changes",
			saveChanges: "Save changes",
			createSettings: "Create settings",
			saving: "Saving...",
		},
		notifications: {
			invalidFileType: {
				title: "Invalid file type",
				message: "Please select an image in .jpg, .jpeg, or .png format.",
			},
			fileTooLarge: {
				title: "File too large",
				message:
					"The selected file exceeds the 1MB limit. Please select a smaller image.",
			},
			saveSuccess: {
				title: "Changes saved successfully",
				message: "The room rules changes were saved successfully.",
			},
			saveError: {
				title: "Something went wrong",
				message: "We couldn't save the changes. Please try again later",
			},
		},
	},
	configurations: {
		title: "Settings",
		description: "Configure the rules and schedules for your reservations",
	},
	management: {
		title: "Reservations",
		description: "Manage your reservations",
		editReservationsButton: "Edit reservations in bulk",
		addReservationButton: "Add reservation",
		todayLabel: "Today",
		confirmedLabel: "Confirmed",
		cancelledLabel: "Cancelled",
		waitingConfirmationLabel: "Waiting confirmation",
		forecastLabel: "Forecast",
		peopleLabel: "people",
		remainingReservationsLabel: "Remaining reservations this month",
		upcomingSpecialDatesLabel: "Upcoming special dates",
		tabs: {
			all: "All",
			received: "Received",
			accommodated: "Accommodated",
			cancelled: "Cancelled",
		},
		statusTags: {
			waitingConfirmation: "waiting confirmation",
			confirmed: "confirmed",
			delayed: "delayed",
			accommodated: "accommodated",
			cancelled: "cancelled",
		},
		notifications: {
			reservationCreated: {
				title: "Reservation created successfully",
				message: "The reservation was created successfully",
			},
			reservationCreatedError: {
				title: "Error creating reservation",
				message:
					"An error occurred while trying to create the reservation. Please try again.",
			},
			reservationConfirmed: {
				title: "Reservation confirmed",
				message: "The reservation was confirmed successfully",
			},
			reservationConfirmedError: {
				title: "Error confirming reservation",
				message: "An error occurred while trying to confirm the reservation",
			},
			reservationCancelled: {
				title: "Reservation cancelled",
				message: "The reservation was cancelled successfully",
			},
			reservationCancelledError: {
				title: "Error cancelling reservation",
				message: "An error occurred while trying to cancel the reservation",
			},
			reservationAccommodated: {
				title: "Reservation accommodated",
				message: "The reservation was accommodated successfully",
			},
			reservationAccommodatedError: {
				title: "Error accommodating reservation",
				message: "An error occurred while trying to accommodate the reservation",
			},
		},
		bulkActions: {
			selectedCount: "{{count}} selected",
			selectAll: "Select all ({{count}})",
			confirmReservations: "Confirm reservations",
			cancelReservations: "Cancel reservations",
		},
		createReservationDrawer: {
			title: "Create reservation",
			editTitle: "Edit reservation",
			labels: {
				peopleCount: "Number of people",
				dateTime: "Reservation date and time",
				room: "Room",
				name: "Full name",
				document: "ID/Document",
				phone: "Phone",
				birthDate: "Date of birth",
				occasion: "Occasion",
				observations: "Observations",
			},
			placeholders: {
				peopleCount: "Select number of people",
				dateTime: "Select date and time",
				room: "Select room",
				name: "Enter customer name",
				document: "Enter customer ID",
				phone: "Phone number",
				birthDate: "MM/DD/YYYY",
				occasion: "Choose an occasion (optional)",
				observations: "Enter an observation (optional)",
			},
			buttons: {
				close: "Close",
				create: "Create reservation",
				update: "Save",
				creating: "Creating...",
				saving: "Saving...",
			},
			occasions: {
				birthday: "Birthday",
				wedding: "Wedding",
				graduation: "Graduation",
				romanticDinner: "Romantic Dinner",
				meeting: "Meeting",
				other: "Other",
			},
			notifications: {
				validationError: "Validation error",
			},
			people: "people",
			person: "person",
			dateTimeFormat: "{{date}} at {{time}}",
		},
		reservationDetailsDrawer: {
			title: "Reservation details",
			loading: "Loading...",
			notFound: "Reservation not found",
			createdAt: "Created at {{date}}",
			labels: {
				observation: "Observation",
				occasion: "Occasion",
				notInformed: "Not informed",
			},
			actions: {
				close: "Close",
				cancel: "Cancel reservation",
				confirm: "Confirm reservation",
				accommodate: "Accommodate customer",
				edit: "Edit",
				editReservation: "Edit reservation",
				editObservation: "Edit observation",
				editOccasion: "Edit occasion",
			},
			alerts: {
				pending: "Not confirmed yet",
				confirmedBy: "Confirmed by {{user}} on {{date}} at {{time}}",
			},
			table: {
				actionHeader: "ACTION",
				dateTimeHeader: "DATE AND TIME",
				actions: {
					requested: "Reservation requested",
					confirmed: "Reservation confirmed",
					accommodated: "Reservation accommodated",
					cancelled: "Reservation cancelled",
					statusChanged: "Status changed",
					confirmationSms: "Confirmation SMS",
					delaySms: "Delay SMS",
				},
				sendSms: "Send SMS",
			},
			places: {
				one: "seat",
				other: "seats",
			},
		},
		filters: {
			searchPlaceholder: "Search reservation",
			statusPlaceholder: "Filter by status",
			roomPlaceholder: "Filter by room",
			statusOptions: {
				all: "All statuses",
				waiting_confirmation: "Pending confirmation",
				confirmed: "Confirmed",
				accommodated: "Accommodated",
				cancelled: "Cancelled",
			},
			roomOptions: {
				all: "All rooms",
			},
		},
	},
	reports,
};
